<template>
    <div class="info">
        <div class="title">保障计划
            <!-- <a class="title-a" v-if="from=='policy'&&(info.statusCode==2||info.statusCode==3)" @click="toEdit">参加人员编辑</a> -->
        </div>
        <Form :label-width="120" ref="form" class="mt15" v-if="info.extraInfo">
            <template >
                <FormItem label="保障起期：" class="w600">{{info.effectiveDateStart}}</FormItem>
                <FormItem label="保障止期：" class="w600">{{info.effectiveDateEnd}}</FormItem>
                <FormItem label="选择类型：" class="w600">{{info.productName}}</FormItem>
                <FormItem label="选择保额：" class="w600">{{info.extraInfo.schemeName}}</FormItem>
                <FormItem label="合同类型：" class="w600">{{info.extraInfo.contractType=='TOTAL'?'总包':'分包'}}</FormItem>
                <FormItem label="总费用：" class="w600">{{info.premium}}</FormItem>
            </template>
        </Form>
    </div>
</template>
<script>
    import ImageShow from '../common/Image'
    export default {
        components: { ImageShow },
        props: {
            info: Object,
            from: {
                type: String,
                default: 'confirm'// confirm/order/policy
            },
        },
        data () {
            return {
                columns: [
                    { title: '序号', type: 'index', width: 70, align: 'center' },
                    { title: '工种', key: 'jobTypeName', width: 150 },
                    { title: '保障方案', key: 'insuranceSchemeName', minWidth: 280 },
                    { title: '姓名', key: 'insurantName', width: 120 },
                    { title: '身份证号', slot: 'insurantCertificateNumber', width: 190 },
                    { title: '性别', slot: 'insurantGender', width: 70 },
                    { title: '年龄', key: 'insurantAge', width: 70 },
                ],
                list: [],
            }
        },
        computed: {
            days () {
                if (this.info.effectiveDateStart && this.info.effectiveDateEnd) {
                    return this.getDays(this.formatDate(this.info.effectiveDateStart), this.formatDate(this.info.effectiveDateEnd));
                } else {
                    return ""
                }
            },
        },
        watch: {
            info (v) {
                if (v.list && v.list.length > 0) {
                    this.list = v.list
                }
            }
        },
        created () {
            if (this.from == 'confirm') {
                // 从确认支付页面来的
                let list = [
                    { title: '保障起期', key: 'effectiveDateStart', width: 180 },
                    { title: '保障止期', key: 'effectiveDateEnd', width: 180 },
                    { title: '保费(元)', slot: 'insurantAmount', width: 110 }
                ]
                this.columns = this.columns.concat(list)
            } else {
                // 从订单保单来的
                let list = [
                    { title: '保障状态', key: 'insuranceStatusName', width: 100 },
                    { title: '保障起期', key: 'effectiveDateStart', width: 180 },
                    { title: '保障止期', key: 'effectiveDateEnd', width: 180 },
                ]
                // if(this.from=='order'){
                //     list.push({title: '保费',key: 'effectiveAmountYuan',width:110})
                //     list.push({title: '应付费用',key: 'insurantAmount',width:100})
                // }else{
                list.push({ title: '保费(元)', slot: 'insurantAmount', width: 110 })
                // }
                list.push({ title: '备注', key: 'remarks', width: 120 })
                this.columns = this.columns.concat(list)
            }

            if (this.info.list && this.info.list.length > 0) {
                this.list = this.info.list
            }
        },
        methods: {
            hideIdCard (str, frontLen = 4, endLen = 3) {
                var len = str.length - frontLen - endLen;
                var star = '';
                for (var i = 0; i < len; i++) {
                    star += '*';
                }
                return str.substring(0, frontLen) + star + str.substring(str.length - endLen);
            },
            toEdit () {
                this.checkOrderRefuseStatus({
                    policyId: this.info.id,
                    bizCode: 'KAS_GZ_GYS'
                }).then(() => {
                    this.$axios.post('/employerLiability/checkUnPaidOrder.json', {
                        id: this.info.id
                    }).then(res => {
                        if (res) {
                            this.$router.push(`/company-group-employer/edit/${this.info.id}`)
                        }
                    });
                })
            }
        },
    }
</script>
<style scoped lang="less">
    .title-a {
        font-size: 14px;
        margin-left: 15px;
    }

    .pb20 {
        padding-bottom: 20px;
    }

    .correctUrlItem {
        margin-right: 20px;
        text-align: center;

        a {
            font-size: 12px;
            display: block;
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/customizedEmployerLiability/RecognizeInfo.vue